export default {
  props: {
    type: { type: String, default: 'image' },
  },

  computed: {
    isImage: (vm) => vm.type === 'image',
    isVideo: (vm) => vm.type === 'video',
    typeName: (vm) => ({ 'image': '图片', 'video': '视频' })[vm.type],
  },
}